export default __webpack_public_path__ + "static/media/logo_footer.461a9db5.png";